import React from 'react'
import { object, arrayOf } from 'prop-types'
import withSend from 'microcosm/addons/with-send'
import PatchLink from 'lib/components/patch-link'
import Select from 'lib/components/select'
import Icon from 'lib/components/icon'
import colors from '../../../config/colors'
import RA from 'ra-config'
import { within, without } from '../../../selection'

const LIMIT = 6

class SidebarHistorical extends React.PureComponent {
  static propTypes = {
    query: object,
    factors: arrayOf(object)
  }

  renderCategoryIndicator(category) {
    if (category.name === 'Large') {
      return <circle fill={colors.defaultGray} r="6" cx="6" cy="6" />
    } else {
      return (
        <circle
          stroke={colors.defaultGray}
          fill="none"
          strokeWidth="2"
          r="5"
          cx="6"
          cy="6"
        />
      )
    }
  }

  renderCategory(category) {
    const { factors, query } = this.props

    const itemsForCategory = factors.filter(
      ({ Category }) => Category === category.name
    )
    const color = colors.defaultGray

    const nextQuery = {
      category: category.name,
      selected: itemsForCategory.map(i => i.Key)
    }

    if (within(query.selected, nextQuery.selected)) {
      nextQuery.selected = without(this.props.selected, query.selected)
    }

    return (
      <li key={`sidebar-category-${category.name}`}>
        <div className="sidebar-list-category">
          <PatchLink
            query={nextQuery}
            trackAs="sidebar-category"
            track={category.name}
          >
            <svg className="sidebar-list-key">
              {this.renderCategoryIndicator(category)}
            </svg>

            <h3 className="type-title">{category.name}</h3>
          </PatchLink>

          <PatchLink
            query={{ category: undefined, selected: undefined }}
            className="sidebar-list-close"
          >
            <Icon type="close" height="20px" width="20px" />
            <span className="screenreader-only">Clear Filter</span>
          </PatchLink>
        </div>

        <ul style={{ color }}>
          {itemsForCategory.map(i => this.renderCategoryItem(i, i.Category))}
        </ul>
      </li>
    )
  }

  renderCategoryItem(item) {
    const { query } = this.props

    const category = item.Category

    const nextQuery = {
      selected: [].concat(item.Key, query.selected || []).slice(0, LIMIT),
      category
    }

    const style = {
      borderLeft: '4px solid',
      borderLeftColor: item.Color,
      color: item.Color
    }

    if (item.isFocused) {
      nextQuery.selected = nextQuery.selected.filter(i => i !== item.Key)
    }

    return (
      <li key={item.Key} style={style}>
        <PatchLink
          query={nextQuery}
          className={item.isFocused ? 'active' : null}
          trackAs="sidebar-item"
          track={`Factors: ${item.Name}`}
        >
          {item.Name} {item.loading ? '(Loading...)' : null}
        </PatchLink>
      </li>
    )
  }

  render() {
    const { topNavigation } = RA.app.page

    return (
      <aside className="sidebar">
        <div className="sidebar__main">
          <Select
            label="Select Equity Category"
            labelFor="location-filter"
            labelVisible={false}
            onChange={this.onSelectChange}
            options={topNavigation}
            selected="/factors"
            selectedText="Factors"
          />

          <ul className="sidebar-list sidebar-list-factors">
            {RA.app.factors.categoryList.map(this.renderCategory, this)}
          </ul>
        </div>
      </aside>
    )
  }

  onSelectChange = event => {
    event.target.blur()
    this.props.send('visit', event.target.value)
  }
}

export default withSend(SidebarHistorical)



// WEBPACK FOOTER //
// ./src/components/factors/historical/sidebar.js